export const sliderData = [
    {
      id: 1,
      recipe: "chineese",
      img: "../../img/food1.jpg",
      name: "Kabob Hut - Sterling Heights",
      info:
        "Lorem ipsum dolor sit amet consectetur adipisicing elit. Vel,repellendus!"
    },
    {
      id: 2,
      recipe: "paris",
      img: "../../img/food2.jpg",
      name: "Kabob Hut 2 - Sterling Heights",
      info:
        "Lorem ipsum dolor sit amet consectetur adipisicing elit. Vel,repellendus!"
    },
    {
      id: 3,
      recipe: "pakistani",
      img: "../../img/food3.jpg",
      name: "Kabob Hut 3 - Sterling Height",
      info:
        "Lorem ipsum dolor sit amet consectetur adipisicing elit. Vel,repellendus!"
    }
  
  ];
  





export const foodData = [
   
    /*{
        category:"mixed-items",
        id: 1,
        recipe: "chineese",
        img: "../../itemImage/item1.jpg",
        name: "Kabob Hut - Sterling Heights",
        info:
          "Lorem ipsum dolor sit amet consectetur adipisicing elit. Vel,repellendus!"
      },
      {
        category:"mixed-items",
        id: 2,
        recipe: "paris",
        img: "../../itemImage/item2.jpg",
        name: "Kabob Hut 2 - Sterling Heights",
        info:
          "Lorem ipsum dolor sit amet consectetur adipisicing elit. Vel,repellendus!"
      },
      {
        category:"mixed-items",
        id: 3,
        recipe: "pakistani",
        img: "../../itemImage/item3.jpg",
        name: "Kabob Hut 3 - Sterling Height",
        info:
          "Lorem ipsum dolor sit amet consectetur adipisicing elit. Vel,repellendus!"
      },
    
      {
        category:"mixed-items",
        id: 4,
        recipe: "chineese",
        img: "../../itemImage/item4.jpg",
        name: "Kabob Hut - Sterling Heights",
        info:
          "Lorem ipsum dolor sit amet consectetur adipisicing elit. Vel,repellendus!"
      },
      {
        category:"mixed-items",
        id: 5,
        recipe: "paris",
        img: "../../itemImage/item5.jpg",
        name: "Kabob Hut 2 - Sterling Heights",
        info:
          "Lorem ipsum dolor sit amet consectetur adipisicing elit. Vel,repellendus!"
      },
      {
        category:"mixed-items",
        id: 6,
        recipe: "pakistani",
        img: "../../itemImage/item6.jpg",
        name: "Kabob Hut 3 - Sterling Height",
        info:
          "Lorem ipsum dolor sit amet consectetur adipisicing elit. Vel,repellendus!"
      },
    
      {
        category:"mixed-items",
        id: 7,
        recipe: "pakistani",
        img: "../../itemImage/item6.jpg",
        name: "Kabob Hut 7 - Sterling Height",
        info:
          "Lorem ipsum dolor sit amet consectetur adipisicing elit. Vel,repellendus!"
      },
      */

      {
        category:"fastFoodData",
        id: 1,
        name: "Burger1",
        img: "../../categoriesImg/fastFood/fastFood1.jpg",
        price: "23.91",
        inCart: false,
        info:
          "Lorem ipsum dolor sit amet consectetur adipisicing elit. Vel,repellendus!"
      
        },
      {
        category:"fastFoodData",
        id: 2,
        name: "Burger2",
        img: "../../categoriesImg/fastFood/fastFood2.jpg",
        price: "23.92",
        inCart: false,
        info:
          "Lorem ipsum dolor sit amet consectetur adipisicing elit. Vel,repellendus!"
      },
      {
        category:"fastFoodData",
        id: 3,
        name: "Burger3",
        img: "../../categoriesImg/fastFood/fastFood3.jpg",
        price: "23.93",
        inCart: false,
        info:
          "Lorem ipsum dolor sit amet consectetur adipisicing elit. Vel,repellendus!"
      },
      {
        category:"fastFoodData",
        id: 4,
        name: "Burger4",
        img: "../../categoriesImg/fastFood/fastFood4.jpg",
        price: "23.94",
        inCart: false,
        info:
          "Lorem ipsum dolor sit amet consectetur adipisicing elit. Vel,repellendus!"
      },
      {
        category:"fastFoodData",
        id: 5,
        name: "Burger5",
        img: "../../categoriesImg/fastFood/fastFood5.jpg",
        price: "23.95",
        inCart: false,
        info:
          "Lorem ipsum dolor sit amet consectetur adipisicing elit. Vel,repellendus!"
      },
      {
        category:"fastFoodData",
        id: 6,
        name: "Burger6",
        img: "../../categoriesImg/fastFood/fastFood6.jpg",
        price: "23.96",
        inCart: false,
        info:
          "Lorem ipsum dolor sit amet consectetur adipisicing elit. Vel,repellendus!"
      },
      {
        category:"drinksData",
        id: 7,
        name: "drink1",
        img: "../../categoriesImg/drinks/drink1.jpg",
        price: "23.91",
        inCart: false,
        info:
          "Lorem ipsum dolor sit amet consectetur adipisicing elit. Vel,repellendus!"
      },
      {
        category:"drinksData",
        id: 8,
        name: "drink2",
        img: "../../categoriesImg/drinks/drink2.jpg",
        price: "23.92",
        inCart: false,
        info:
          "Lorem ipsum dolor sit amet consectetur adipisicing elit. Vel,repellendus!"
      },
      {
        category:"drinksData",
        id: 9,
        name: "drink3",
        img: "../../categoriesImg/drinks/drink3.jpg",
        price: "23.93",
        inCart: false,
        info:
          "Lorem ipsum dolor sit amet consectetur adipisicing elit. Vel,repellendus!"
      },
      {
        category:"drinksData",
        id: 10,
        name: "drink4",
        img: "../../categoriesImg/drinks/drink4.jpg",
        price: "23.94",
        inCart: false,
        info:
          "Lorem ipsum dolor sit amet consectetur adipisicing elit. Vel,repellendus!"
      },
      {
        category:"drinksData",
        id: 11,
        name: "drink5",
        img: "../../categoriesImg/drinks/drink1.jpg",
        price: "23.95",
        inCart: false,
        info:
          "Lorem ipsum dolor sit amet consectetur adipisicing elit. Vel,repellendus!"
      },
      {
        category:"snacksData",
        id: 12,
        name: "snack1",
        img: "../../categoriesImg/snacks/snack1.jpg",
        price: "23.91",
        inCart: false,
        info:
          "Lorem ipsum dolor sit amet consectetur adipisicing elit. Vel,repellendus!"
      },
      {
        category:"snacksData",
        id: 13,
        name: "snack2",
        img: "../../categoriesImg/snacks/snack2.jpg",
        price: "23.92",
        inCart: false,
        info:
          "Lorem ipsum dolor sit amet consectetur adipisicing elit. Vel,repellendus!"
      },
      {
        category:"snacksData",
        id: 14,
        name: "snack3",
        img: "../../categoriesImg/snacks/snack3.jpg",
        price: "23.93",
        inCart: false,
        info:
          "Lorem ipsum dolor sit amet consectetur adipisicing elit. Vel,repellendus!"
      }
  ];
  